const BRANDS = ["MEN'S HEALTH", "SHAPE", "TODAY", "PopSugar", "BuzzFeed", "Well+Good"];

export const LogoStrip = () => (
  <section data-testid="logo-strip" className="bg-slate-900 border-y border-slate-800 py-10">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <p className="text-center text-xs uppercase tracking-[0.25em] font-bold text-slate-500 mb-7">As featured in</p>
      <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-5">
        {BRANDS.map((b) => (
          <span key={b} data-testid={`logo-${b.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="font-display text-lg sm:text-xl font-extrabold text-slate-600 tracking-tight select-none">{b}</span>
        ))}
      </div>
    </div>
  </section>
);
